import React from "react";
import Lottie from "lottie-react";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./SettingEarningsGoal.scss";
import OnboardingHeader from "../../../components/Headers/OnboardingHeader/OnboardingHeader";
import ShieldLoadingAnimation from "../../../assets/animations/shield.json";
import OnboardingContainer from "../../../components/onboarding/OnboardingContainer/OnboardingContainer";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";
import { OnboardingSteps } from "../../../utils/constants";

export default function SettingEarningsGoal() {
  const { goToStep } = useOnboardingSteps();
  const { t } = useTranslation("common", { keyPrefix: "onboarding" });

  return (
    <OnboardingContainer className="d-flex flex-column setting-earnings-goal-page">
      <div>
        <OnboardingHeader showProgress={false} showBackButton={false} />
      </div>
      <Stack gap={4} className="content">
        <div className="animation-container">
          <Lottie
            animationData={ShieldLoadingAnimation}
            loop={false}
            style={{ scale: 1.16 }}
            onComplete={() => goToStep(OnboardingSteps.SIGN_UP)}
          />
        </div>
        <p className="setting-goals-text">{t("setting_your_goal")}</p>
      </Stack>
    </OnboardingContainer>
  );
}
